import type { LayoutMode } from "./layoutMode.js";

export function isWidePath(pathname: string): boolean {
  return pathname === "/w" || pathname.startsWith("/w/");
}

export function toWidePath(pathname: string): string {
  if (isWidePath(pathname)) return pathname;
  return pathname === "/" ? "/w" : `/w${pathname.startsWith("/") ? pathname : `/${pathname}`}`;
}

export function toMobilePath(pathname: string): string {
  if (!isWidePath(pathname)) return pathname;
  const mobile = pathname.slice(2);
  return mobile || "/";
}

export function pathForMode(pathname: string, mode: LayoutMode): string {
  return mode === "wide" ? toWidePath(pathname) : toMobilePath(pathname);
}
